export const LOAD_THEME = '[THEMES] LOAD_THEME'
